/* eslint-disable */
import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import useConfig from "hooks/useConfig";
import { useTranslation } from "react-i18next";

const data = {
  "stepMinutes": 5,
  "series": {
    "PV_HOLD": {
      "power.pct": [63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73,63.73]
    },
    "RAW_APPLY": {
      "power.pct": [63.73,63.73,63.73,63.73,63.73,63.73,13.73,13.73,13.73,13.73,13.73,13.73,13.73,13.73,13.73,13.73,13.73,13.73,13.73]
    }
  }
};

// function PowerOperationRateGraph({ data }) {
function PowerOperationRateGraph({infoId}) {
  const { mode } = useConfig();
  const { t } = useTranslation();

  const isLight = mode === "light";

  const textColor = isLight ? "#262626" : "#e5e7eb";
  const subTextColor = isLight ? "#6b7280" : "#9ca3af";
  const bgColor = isLight ? "#ffffff" : "#202020";
  const gridLineColor = isLight
    ? "rgba(0,0,0,0.08)"
    : "rgba(255,255,255,0.12)";

  const option = useMemo(() => {
    /* ===============================
       1️⃣ 데이터 파싱 (API 구조 그대로)
    =============================== */
    const stepMinutes = data.stepMinutes;
    const pvPct = data.series.PV_HOLD["power.pct"];
    const rawPct = data.series.RAW_APPLY["power.pct"];

    const times = pvPct.map((_, i) => `+${i * stepMinutes}분`);

    /* ===============================
       2️⃣ RAW 적용 시점 계산
    =============================== */
    let applyIndex = 0;
    for (let i = 1; i < rawPct.length; i++) {
      if (rawPct[i] !== rawPct[i - 1]) {
        applyIndex = i;
        break;
      }
    }
    const applyLabel = `${applyIndex * stepMinutes}분`;

    /* ===============================
       3️⃣ ECharts option
    =============================== */
    return {
      backgroundColor: bgColor,
      textStyle: { color: textColor },

      title: {
        text: `${t("message.common.chip.power.operation.rate.graph")} (PV vs RAW)`,
        subtext: `${t("message.common.text.raw.apply.time")}: ${applyLabel}`,
        left: "center",
        top: '10px',
        textStyle: { color: textColor, fontSize: 18 },
        subtextStyle: { color: subTextColor },
      },

      tooltip: {
        trigger: "axis",
        formatter: (params) => {
          return params
            .map(
              (p) =>
                `${p.marker} ${p.seriesName}: <b>${p.data}%</b>`
            )
            .join("<br/>");
        },
      },

      legend: {
        top: 60,
        left: "center",
        icon: "line",
        textStyle: { color: subTextColor },
        data: [
          t("message.common.text.current.operation.rate"),
          t("message.common.text.recommended.operation.rate"),
        ],
      },

      grid: { left: 55, right: 20, top: 110, bottom: 45 },

      xAxis: {
        type: "category",
        boundaryGap: false,
        data: times,
        axisLabel: { color: subTextColor },
        axisLine: { lineStyle: { color: gridLineColor } },
      },

      yAxis: {
        type: "value",
        name: `${t("message.common.text.power.operation.rate.percent")} (%)`,
        min: 0,
        axisLabel: { color: subTextColor },
        splitLine: { lineStyle: { color: gridLineColor } },
      },

      dataZoom: [{ type: "inside" }],

      series: [
        {
          name: t("message.common.text.current.operation.rate"),
          type: "line",
          smooth: true,
          symbol: "none",
          data: pvPct,
          lineStyle: { width: 2, color: "#ef4444" },
          areaStyle: { opacity: 0.12 },
          markLine: {
            symbol: "none",
            label: { formatter: t("message.common.text.raw.apply") },
            lineStyle: { type: "dashed" },
            data: [{ xAxis: times[applyIndex] }],
          },
        },
        {
          name: t("message.common.text.recommended.operation.rate"),
          type: "line",
          smooth: true,
          symbol: "none",
          data: rawPct,
          lineStyle: { width: 3, color: "#22c55e" },
          areaStyle: { opacity: 0.12 },
        },
      ],
    };
  }, [data, mode, t]);

  return (
    <div style={{ width: "100%", height: 360 }}>
      <ReactECharts
        option={option}
        style={{ width: "100%", height: "100%" }}
        notMerge
        lazyUpdate
      />
    </div>
  );
}

export default PowerOperationRateGraph;
